import { Modal, ModalProps } from 'components/Modal';
import { ModalBody } from 'components/Modal/ModalBody';
import { FeedbackThankYouGraphic } from 'graphics';
import { ModalActions } from 'components/Modal/ModalActions';
import { Button } from 'components/Button';
import { useContext, useEffect, useMemo } from 'react';
import { AlertIcon } from 'icons/outline';
import { ModalIconColor } from 'components/Modal/Modal.types';
import isBoolean from 'lodash/isBoolean';
import { HiringUpdateFlowContext } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { HiringUpdateFlowSteps } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateFlow.constants';
import { InputInstructions } from 'features/EmployerHiringUpdateFlow/InputInstructions';

export const FeedbackAddMoreStep = () => {
  const { open, step, error, hiredMorePeople, setHiredMorePeople, goToNextStep } =
    useContext(HiringUpdateFlowContext);

  const modalProps: Partial<ModalProps> = useMemo(() => {
    if (Boolean(error)) {
      return {
        heading: <span className="text-primary-poppy-red">Something went wrong</span>,
        IconElement: AlertIcon,
        iconColor: ModalIconColor.ERROR,
      };
    }

    return {
      heading: <span className="text-primary-pure-blue">Thanks for your feedback!</span>,
      panelProps: {
        className: 'sm:!max-w-[396px]',
      },
    };
  }, [error]);

  const handleConfirmHiringMore = () => {
    setHiredMorePeople(true);
  };

  const handleDenyHiringMore = () => {
    setHiredMorePeople(false);
  };

  useEffect(() => {
    if (isBoolean(hiredMorePeople)) {
      goToNextStep();
    }
  }, [hiredMorePeople]);

  return (
    <Modal
      size="sm"
      open={open && step === HiringUpdateFlowSteps.FEEDBACK_ADD_MORE}
      onClose={goToNextStep}
      actionRequired
      {...modalProps}
    >
      {Boolean(error) ? (
        <>
          <ModalBody className="my-3">
            <p className="text-center">
              Please try again. If the error persists, contact our support team.
            </p>
          </ModalBody>

          <ModalActions>
            <Button type="button" size="lg" fullWidth onClick={goToNextStep}>
              OK
            </Button>
          </ModalActions>
        </>
      ) : (
        <>
          <ModalBody>
            <InputInstructions>Did you hire anyone else?</InputInstructions>
            <FeedbackThankYouGraphic className="mx-auto w-[154px] mt-6" />
          </ModalBody>

          <ModalActions>
            <Button type="button" size="lg" fullWidth onClick={handleConfirmHiringMore}>
              Yes, I did
            </Button>
            <Button
              type="button"
              size="lg"
              variant="outline"
              fullWidth
              onClick={handleDenyHiringMore}
            >
              No, I didn&apos;t
            </Button>
          </ModalActions>
        </>
      )}
    </Modal>
  );
};
